import { render, staticRenderFns } from "./ComptaExport.vue?vue&type=template&id=68afb066&scoped=true&"
import script from "./ComptaExport.vue?vue&type=script&lang=js&"
export * from "./ComptaExport.vue?vue&type=script&lang=js&"
import style0 from "./ComptaExport.vue?vue&type=style&index=0&id=68afb066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68afb066",
  null
  
)

export default component.exports